import ScreenshotCarousel, { ScreenshotItem } from './ScreenshotCarousel';

const MobileScreenshotsGallery = () => {
  const screenshots: ScreenshotItem[] = [
    {
      src: '/screenshots/app-mobile/mobile-1.PNG',
      alt: 'Écran d\'accueil - Carte interactive',
      title: 'Étape 1 : Découverte',
      description: 'Visualisez tous les parkings disponibles autour de vous sur une carte interactive. Chaque parking affiche sa disponibilité en temps réel, sa localisation précise et ses informations essentielles.',
      step: 'Découverte des parkings'
    },
    {
      src: '/screenshots/app-mobile/mobile-2.PNG',
      alt: 'Sélection de parking',
      title: 'Étape 2 : Sélection',
      description: 'Consultez les détails de chaque parking : tarifs horaires, distance depuis votre position et horaires d\'ouverture... Choisissez celui qui correspond le mieux à vos besoins.',
      step: 'Sélection du parking'
    },
    {
      src: '/screenshots/app-mobile/mobile-3.PNG',
      alt: 'Sélection de parking',
      title: 'Étape 3 : Choisir le parking',
      description: 'Consultez le détails du parking sélectionné',
      step: 'Choix du parking'
    },
    {
      src: '/screenshots/app-mobile/mobile-4.PNG',
      alt: 'Création de ticket',
      title: 'Étape 4 : Configuration',
      description: 'Configurez votre ticket de stationnement : sélectionnez votre véhicule dans la liste, choisissez la durée de stationnement souhaitée et vérifiez le montant total avant de continuer.',
      step: 'Création du ticket'
    },
    {
      src: '/screenshots/app-mobile/mobile-5.PNG',
      alt: 'Ticket actif',
      title: 'Étape 5 : Suivi actif',
      description: 'Votre ticket est maintenant actif ! Suivez en temps réel le temps restant, recevez des notifications avant expiration et prolongez votre stationnement d\'un simple geste si nécessaire.',
      step: 'Gestion du ticket'
    },
    {
      src: '/screenshots/app-mobile/mobile-6.PNG',
      alt: 'Historique des tickets',
      title: 'Étape 6 : Historique',
      description: 'Consultez l\'historique complet de tous vos tickets passés et présents. Suivez en temps réel le temps restant, recevez des notifications avant expiration et prolongez votre stationnement d\'un simple geste si nécessaire.',
      step: 'Historique tickets'
    },
    {
      src: '/screenshots/app-mobile/mobile-7.PNG',
      alt: 'Portefeuille électronique',
      title: 'Étape 7 : Portefeuille',
      description: 'Rechargez votre portefeuille électronique à tout moment par carte bancaire. Consultez votre solde actuel et l\'historique détaillé de toutes vos transactions pour un suivi complet.',
      step: 'Gestion du portefeuille'
    },
    {
      src: '/screenshots/app-mobile/mobile-8.PNG',
      alt: 'Profil utilisateur',
      title: 'Étape 8 : Profil',
      description: 'Gérez votre compte personnel : ajoutez ou modifiez vos véhicules, consultez vos informations personnelles et accédez à toutes les options de configuration de votre profil.',
      step: 'Profil utilisateur'
    },
  ];

  return (
    <ScreenshotCarousel
      screenshots={screenshots}
      variant="mobile"
      colorScheme={{
        badge: 'bg-blue-100 text-blue-800',
        activeBadge: 'bg-blue-600',
        border: 'border-blue-600',
        ring: 'ring-blue-200',
        indicator: 'bg-blue-600',
      }}
      thumbnailTitle="Parcours complet en 8 étapes"
      showThumbnails={false}
      autoplay={false}
    />
  );
};

export default MobileScreenshotsGallery;
